import { useEffect } from "react";

const CURRENT_VERSION = process.env.REACT_APP_BUILD_VERSION;

export function useVersionCheck() {
    useEffect(() => {
        const check = async () => {
            try {
                const res = await fetch("/meta.json", { cache: "no-store" });
                if (!res.ok) return;
                const { version } = await res.json();
                if (version !== CURRENT_VERSION) {
                    // Option A: Hard reload
                    const url = new URL(window.location.href);
                    url.searchParams.set('v', Date.now().toString());
                    window.location.href = url.toString();
                    // Option B: Set state to show a "New version available" banner
                }
            } catch (err) {
                console.error("Version check failed", err);

            }
        };

        check();
        const interval = setInterval(check, 60000);
        return () => clearInterval(interval);
    }, []);
}
